import React from "react";

interface TabBarProps {
  value: string;
  onChange: (newValue: string) => void;
  children: JSX.Element[];
  textColor: string;
  indicatorColor: string;
}

export function TabBar({ children, value, onChange, textColor, indicatorColor }: TabBarProps) {
  return (
    <div className="flex items-center gap-6">
      {children.map((i, index) => React.cloneElement(i,
        {
          onClick: onChange,
          activeValue: value,
          textColor,
          indicatorColor,
          key: index
        }))}
    </div>
  );
}
